query GetEventSettings {
  eventSettings {
    termsUrl
    termsVersion
    upcomingEventsUsingDefaultCount
  }
}
